module.exports = __webpack_public_path__ + "img/hover-imgs-item-4.0a71d419.png";